import { apiClientWithMiddleware } from './API';
const BASIC_SETUP_GROUPKEY = 'playbook_basic_setup';
const getPlaybookOnboardingProgress = (groupKey, portalId) => apiClientWithMiddleware().get(`usercontext-app/v1/onboarding/progress/${groupKey}/summary`, {
  query: {
    portalId
  }
});
const getPlaybook = (playbookId, portalId) => apiClientWithMiddleware().post(`growth-coaching/app/v1/fetch-playbooks?portalId=${portalId}`, {
  data: {
    ids: [playbookId]
  }
});
const getActivePlaybooks = portalId => apiClientWithMiddleware().get(`growth-coaching/app/v1/active`, {
  query: {
    portalId
  }
});
const getPrimaryPlaybookId = playbooks => {
  var _playbooks$find, _playbooks$;
  if (!playbooks) {
    return 0;
  }
  return (playbooks === null || playbooks === void 0 || (_playbooks$find = playbooks.find(item => item.isPrimary && item.playbook)) === null || _playbooks$find === void 0 ? void 0 : _playbooks$find.playbook) || (playbooks === null || playbooks === void 0 || (_playbooks$ = playbooks[0]) === null || _playbooks$ === void 0 ? void 0 : _playbooks$.playbook) || 0;
};
const getPlaybookGroupKey = playbooks => {
  if (!playbooks || playbooks.length === 0) {
    return '';
  }
  return playbooks[0].taskGroupKey;
};
export const getFormattedGrowthPlanProgressData = async portalId => {
  const activePlaybooks = await getActivePlaybooks(portalId);
  const primaryPlaybookId = getPrimaryPlaybookId(activePlaybooks);
  if (primaryPlaybookId === 0) {
    const setupProgress = await getPlaybookOnboardingProgress(BASIC_SETUP_GROUPKEY, portalId);
    return {
      progress: setupProgress.percentage,
      selectedView: 'growth-plan',
      groupKey: BASIC_SETUP_GROUPKEY
    };
  }
  const fullPlaybooks = await getPlaybook(primaryPlaybookId, portalId);
  const fullPlaybookTaskGroupKey = getPlaybookGroupKey(fullPlaybooks);
  if (!fullPlaybookTaskGroupKey) {
    return {
      progress: 0,
      selectedView: 'growth-plan',
      groupKey: ''
    };
  }
  const taskProgress = await getPlaybookOnboardingProgress(fullPlaybookTaskGroupKey, portalId);
  return {
    progress: taskProgress.percentage,
    selectedView: 'growth-plan',
    groupKey: fullPlaybookTaskGroupKey
  };
};